(ns practitest.frontend.components2.dashboard.subs
  (:require [practitest.frontend.components2.dashboard.helpers :as helpers]
            [practitest.frontend.components2.issue-status :as issue-status]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.subs :as rsubs]
            [re-frame.core :as r]))

(r/reg-sub
 ::item
 (fn [db [_ id]]
   (get-in db [:dashboard-items id])))

;; (r/reg-sub
;;  ::readiness-index
;;  (fn [db [_ id]]
;;    {:ccs :0.9, :ecs :0.31, :rdrs :0.67, :rrqi :0.64, :trimester :1}))

(r/reg-sub
 ::chart
 (fn [[_ id]]
   {:item          (r/subscribe [::item id])})
 (fn [{:keys [item system-colors]} _]
   (when (seq item)
     (let [issue-colors   (-> issue-status/statuses-map
                              (update-vals :color)
                              (update-vals helpers/resolve-css-color))
           system-colors  (:chart/status-colors item)
           colors-palette (-> item
                              (helpers/palette [system-colors issue-colors])
                              (helpers/assign-colors (or (:chart/legend-labels item) [])))]
       (-> item
           (assoc :chart/colors-palette colors-palette)
           p/transform-data)))))
